import { 
    IInvoiceReport1, 
    IInvoiceReport2, 
    IInvoiceFCReport1,
    IInvoiceFCReport2,
    IInvoice as Invoice
} from '../../models/invoice';
import { MultiResponseType } from '../../models/multiResponseType';
import { SingleResponseType } from '../../models/singleResponseType';

export enum ActionType {
    FETCH_INVOICES = 'FETCH_INVOICES',
    FETCH_INVOICES_SUCCESS = 'FETCH_INVOICES_SUCCESS',
    FETCH_INVOICES_FAIL = 'FETCH_INVOICES_FAIL',
    FETCH_INVOICEREPORT1 = 'FETCH_INVOICEREPORT1',
    FETCH_INVOICEREPORT1_SUCCESS = 'FETCH_INVOICEREPORT1_SUCCESS',
    FETCH_INVOICEREPORT1_FAIL = 'FETCH_INVOICEREPORT1_FAIL',
    FETCH_INVOICEREPORT2 = 'FETCH_INVOICEREPORT2',
    FETCH_INVOICEREPORT2_SUCCESS = 'FETCH_INVOICEREPORT2_SUCCESS',
    FETCH_INVOICEREPORT2_FAIL = 'FETCH_INVOICEREPORT2_FAIL',   
    FETCH_INVOICEFCREPORT1 = 'FETCH_INVOICEFCREPORT1',
    FETCH_INVOICEFCREPORT1_SUCCESS = 'FETCH_INVOICEFCREPORT1_SUCCESS',
    FETCH_INVOICEFCREPORT1_FAIL = 'FETCH_INVOICEFCREPORT1_FAIL',
    FETCH_INVOICEFCREPORT2 = 'FETCH_INVOICEFCREPORT2',
    FETCH_INVOICEFCREPORT2_SUCCESS = 'FETCH_INVOICEFFCREPORT2_SUCCESS',
    FETCH_INVOICEFCREPORT2_FAIL = 'FETCH_INVOICEFCREPORT2_FAIL',  
    ADD_INVOICE = 'ADD_INVOICE',
    ADD_INVOICE_SUCCESS = 'ADD_INVOICE_SUCCESS',
    ADD_INVOICE_FAIL = 'ADD_INVOICE_FAIL',
    EDIT_INVOICE = 'EDIT_INVOICE',
    EDIT_INVOICE_SUCCESS = 'EDIT_INVOICE_SUCCESS',
    EDIT_INVOICE_FAIL = 'EDIT_INVOICE_FAIL',
    DELETE_INVOICE = 'DELETE_INVOICE',
    DELETE_INVOICE_SUCCESS = 'DELETE_INVOICE_SUCCESS',
    DELETE_INVOICE_FAIL = 'DELETE_INVOICE_FAIL'
}

export interface IFetchInvoices {
    type: ActionType.FETCH_INVOICES;
}
export interface IFetchInvoicesSuccess {
    type: ActionType.FETCH_INVOICES_SUCCESS;
    payload: MultiResponseType<Invoice>;
}
export interface IFetchInvoicesFail {
    type: ActionType.FETCH_INVOICES_FAIL;
    payload: string | null;
}

export interface IFetchInvoiceReport1 {
    type: ActionType.FETCH_INVOICEREPORT1;
}
export interface IFetchInvoiceReport1Success {
    type: ActionType.FETCH_INVOICEREPORT1_SUCCESS;
    payload: SingleResponseType<IInvoiceReport1>;
}
export interface IFetchInvoiceReport1Fail {
    type: ActionType.FETCH_INVOICEREPORT1_FAIL;
    payload: string | null;
}

export interface IFetchInvoiceReport2 {
    type: ActionType.FETCH_INVOICEREPORT2;
}
export interface IFetchInvoiceReport2Success {
    type: ActionType.FETCH_INVOICEREPORT2_SUCCESS;
    payload: MultiResponseType<IInvoiceReport2>;
}
export interface IFetchInvoiceReport2Fail {
    type: ActionType.FETCH_INVOICEREPORT2_FAIL;
    payload: string | null;
}

export interface IFetchInvoiceFCReport1 {
    type: ActionType.FETCH_INVOICEFCREPORT1;
}
export interface IFetchInvoiceFCReport1Success {
    type: ActionType.FETCH_INVOICEFCREPORT1_SUCCESS;
    payload: SingleResponseType<IInvoiceFCReport1>;
}
export interface IFetchInvoiceFCReport1Fail {
    type: ActionType.FETCH_INVOICEFCREPORT1_FAIL;
    payload: string | null;
}

export interface IFetchInvoiceFCReport2 {
    type: ActionType.FETCH_INVOICEFCREPORT2;
}
export interface IFetchInvoiceFCReport2Success {
    type: ActionType.FETCH_INVOICEFCREPORT2_SUCCESS;
    payload: MultiResponseType<IInvoiceFCReport2>;
}
export interface IFetchInvoiceFCReport2Fail {
    type: ActionType.FETCH_INVOICEFCREPORT2_FAIL;
    payload: string | null;
}

export interface IAddInvoice {
    type: ActionType.ADD_INVOICE;
}
export interface IAddInvoiceSuccess {
    type: ActionType.ADD_INVOICE_SUCCESS;
    payload: Invoice;
}
export interface IAddInvoiceFail {
    type: ActionType.ADD_INVOICE_FAIL;
    payload: string | null;
}

export interface IEditInvoice {
    type: ActionType.EDIT_INVOICE;
}
export interface IEditInvoiceSuccess {
    type: ActionType.EDIT_INVOICE_SUCCESS;
    payload: Invoice;
}
export interface IEditInvoiceFail {
    type: ActionType.EDIT_INVOICE_FAIL;
    payload: string | null;
}
export interface IDeleteInvoice {
    type: ActionType.DELETE_INVOICE;
}
export interface IDeleteInvoiceSuccess {
    type: ActionType.DELETE_INVOICE_SUCCESS;
    payload: number;
}
export interface IDeleteInvoiceFail {
    type: ActionType.DELETE_INVOICE_FAIL;
    payload: string | null;
}

export type Action =
    | IFetchInvoices
    | IFetchInvoicesSuccess
    | IFetchInvoicesFail
    | IFetchInvoiceReport1
    | IFetchInvoiceReport1Success
    | IFetchInvoiceReport1Fail
    | IFetchInvoiceReport2
    | IFetchInvoiceReport2Success
    | IFetchInvoiceReport2Fail
    | IFetchInvoiceFCReport1
    | IFetchInvoiceFCReport1Success
    | IFetchInvoiceFCReport1Fail
    | IFetchInvoiceFCReport2
    | IFetchInvoiceFCReport2Success
    | IFetchInvoiceFCReport2Fail
    | IAddInvoice
    | IAddInvoiceSuccess
    | IAddInvoiceFail
    | IEditInvoice
    | IEditInvoiceSuccess
    | IEditInvoiceFail
    | IDeleteInvoice
    | IDeleteInvoiceSuccess
    | IDeleteInvoiceFail
